import React from 'react';
import PropTypes from 'prop-types';

import { useSmallScreen } from 'utils/hooks';
import { Loader } from 'components';
import { Box, Button } from '@mui/material';

const preventDefaultHandler = e => e.preventDefault();

const SubmitButton = props => {
    const { text, disabled, fullWidth, loading, buttonStyle, sx, buttonSx, ...rest } = props;
    const isSmall = useSmallScreen();

    return (
        <Box
            className={buttonStyle}
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            marginTop={4}
            sx={sx}
        >
            <Button
                disableElevation
                disableRipple
                onTouchMove={preventDefaultHandler}
                onTouchStart={preventDefaultHandler}
                fullWidth={isSmall || fullWidth}
                variant={disabled ? 'outlined' : 'contained'}
                disabled={disabled || loading}
                sx={theme => ({
                    padding: '17px 50px',
                    ...(typeof buttonSx === 'function' ? buttonSx(theme) : buttonSx),
                })}
                {...rest}
            >
                <Loader loading={loading} color="inherit" size={22} marginTop={0}>
                    {text}
                </Loader>
            </Button>
        </Box>
    );
};

SubmitButton.propTypes = {
    disabled: PropTypes.bool,
    buttonStyle: PropTypes.string,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    fullWidth: PropTypes.bool,
    loading: PropTypes.bool,
};

export default SubmitButton;
